import React from 'react';
import { useSelector } from 'react-redux';
import { Text, TextProps } from 'evergreen-ui';
import { stationsIdsLengthSelector } from 'Features/App/Dictionaries/dictionariesSlice';
import { filteredStationsIdsLengthSelector } from './selectors';

/** Сколько станций найдено из всех. Значения данных из слайсов. */
export function StationsFoundCount(props: TextProps) {
  const filteredLength = useSelector(filteredStationsIdsLengthSelector);
  const allLength = useSelector(stationsIdsLengthSelector);

  return (
    <Text {...props}>{`Станции: ${filteredLength} из ${allLength}`}</Text>
  );
}
export const MemoStationsFoundCount = React.memo(StationsFoundCount);
MemoStationsFoundCount.displayName = 'MemoStationsFoundCount';
export default StationsFoundCount;
